import './Input.scss'
import {useState} from 'react'

export const Input = ({
  id, type, label, autoComplete, autoFocus, placeHolder, required, value, onChange, onBlur, onEnter, forgotPwd, infoMsg, errorMsg, inline, title, ...props
}) => {
    const [showPwd, setShowPwd] = useState(false)

    const togglePwdVisibility = () => {
        setShowPwd(!showPwd)
    }

    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            if (onEnter) onEnter(e)
        }
    }

    return (
        <span className={'input-wrapper'}>
            {label && <label className={'label'} title={title} htmlFor={id}>{label}</label>}
            <input
                id={id}
                className="input"
                type={showPwd ? 'text' : type}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                placeholder={placeHolder}
                required={required}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                data-variant={type}
                data-state={errorMsg ? 'error-msg' : 'default'}
                data-inline={inline}
                size={inline ? 20 : ''}
                onKeyDown={handleKeyDown}
                {...props}
            />
            {type === 'password' && autoComplete === 'new-password' &&
                <span
                    className={'pwd-text'}
                    data-state={value.trim().length >= 8 ? 'checked' : 'unchecked'}
                >
                    <span className="material-symbols-outlined">
                        {value.trim().length >= 8 ? 'task_alt' : 'report'}
                    </span>
                    <span className={'condition'}>8 or more characters</span>
                </span>
            }
            {errorMsg &&
                <span className={'input-error-msg'}>
                    <span className="material-symbols-outlined">error</span>
                    {errorMsg}
                </span>
            }
            {infoMsg &&
                <span className={'input-info-msg'}>
                    <span className="material-symbols-outlined">info</span>
                    {infoMsg}
                </span>
            }
            {type === 'password' &&
                <button className={'show-psw-btn'} type={'button'} onClick={togglePwdVisibility}>
                        <span className="material-symbols-outlined">
                            {showPwd ? 'visibility_off' : 'visibility'}
                        </span>
                </button>
            }
            {/*{type === 'password' && autoComplete === 'current-password' &&*/}
            {/*    <button className={'forgot-pwd-btn'} type={'button'} onClick={forgotPwd}>*/}
            {/*        Forgot password?*/}
            {/*    </button>*/}
            {/*}*/}
        </span>
    )
}
